import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '@/lib/api';
import { BookOpen } from 'lucide-react';

export default function Courses() {
  const [courses, setCourses] = useState([]);
  useEffect(() => { api.get('/courses').then(r => setCourses(r.data)).catch(()=>{}); }, []);
  return (
    <div className="kc-container py-12">
      <div className="text-[11px] tracking-[0.18em] uppercase text-muted-kc">All Courses</div>
      <h1 className="font-display uppercase text-4xl md:text-5xl mt-2">Kickass Course Library</h1>
      <p className="text-muted-kc mt-2 max-w-2xl">Hand-crafted courses from Mickey Trivett to help you master mindset, growth, and intentional living.</p>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-5">
        {courses.map((c) => (
          <Link key={c.id} to={`/courses/${c.slug}`} className="group bg-white border border-kc-strong rounded-[var(--kc-radius-md)] overflow-hidden hover:shadow-kc transition-shadow relative" data-testid={`course-card-${c.slug}`}>
            <div className="absolute top-0 left-0 right-0 h-[2px] bg-gold" />
            <div className="grid grid-cols-3 gap-0">
              <div className="col-span-1 bg-ink relative">
                <img src={c.cover_image} alt={c.title} className="w-full h-full object-cover aspect-[3/4]" />
              </div>
              <div className="col-span-2 p-5">
                <div className="text-[11px] tracking-[0.18em] uppercase text-muted-kc">{c.subtitle}</div>
                <h2 className="font-display uppercase text-3xl md:text-4xl mt-1 leading-tight">{c.title}</h2>
                <p className="mt-2 text-sm text-ink-2 line-clamp-3">{c.description}</p>
                <div className="mt-3 inline-flex items-center gap-1 text-xs text-muted-kc"><BookOpen size={14}/> {c.lesson_count} lessons</div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
